import { useEffect } from 'react'

type PageMeta = {
  title: string
  description: string
  robots: string
}

function upsertMeta(name: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

// Review-only prototype metadata. Not intended for a production domain.
export function usePageMeta({ title, description, robots }: PageMeta) {
  useEffect(() => {
    document.title = title
    document.documentElement.lang = 'en'
    upsertMeta('description', description)
    upsertMeta('robots', robots)
  }, [title, description, robots])
}
